// Switch verizon link based on MagSafe product title
// $(document).ready(function () {
//   function currentSwatchSelect(titleText, text) {
//     switch (titleText) {
//       case "ICON Case for MagSafe for iPhone 15 Pro":
//         switch (text) {
//           case "Brown Pebbled Leather":
//             $('.verizon-link').attr('href', 'https://www.verizon.com/products/incase-icon-mobile-case-with-pebbled-leather-with-magsafe-for-iphone-15-pro');
//             $('.klaviyo-bis-trigger').addClass('hidden');
//             $('.verizon-link').show();
//             $('.buy-buttons-row button[type="submit"]').hide();
//             break;
//           case "Woolenex Graphite":
//             $('.verizon-link').attr('href', 'https://www.verizon.com/products/incase-icon-mobile-case-with-woolenex-with-magsafe-for-iphone-15-pro');
//             $('.klaviyo-bis-trigger').addClass('hidden');
//             $('.verizon-link').show();
//             $('.buy-buttons-row button[type="submit"]').hide();
//             break;
//           default:
//             $('.klaviyo-bis-trigger').removeClass('hidden');
//             $('.verizon-link').hide();
//             $('.buy-buttons-row button[type="submit"]').show();
//         }
//         break;
//       case "ICON Case for MagSafe for iPhone 15 Pro Max":
//         switch (text) {
//           case "Brown Pebbled Leather":
//             $('.verizon-link').attr('href', 'https://www.verizon.com/products/incase-icon-mobile-case-with-pebbled-leather-with-magsafe-for-iphone-15-pro-max');
//             $('.klaviyo-bis-trigger').addClass('hidden');
//             $('.verizon-link').show();
//             $('.buy-buttons-row button[type="submit"]').hide();
//             break;
//           case "Woolenex Graphite":
//             $('.verizon-link').attr('href', 'https://www.verizon.com/products/incase-icon-mobile-case-with-woolenex-with-magsafe-for-iphone-15-pro-max');
//             $('.klaviyo-bis-trigger').addClass('hidden');
//             $('.verizon-link').show();
//             $('.buy-buttons-row button[type="submit"]').hide();
//             break;
//           default:
//             $('.klaviyo-bis-trigger').removeClass('hidden');
//             $('.verizon-link').hide();
//             $('.buy-buttons-row button[type="submit"]').show();
//         }
//         break;
//     }
//   }
//   // Hide Back in stock trigger for specific color variants on page load
//   const titleText = $('.product-form .product-title').text();
//   const text = $('body.template-suffix-icon-case-magsafe-iphone .option-selector input:checked + label').text().trim();
//   currentSwatchSelect(titleText, text);
//   // Hide Back in stock trigger for specific color variants on click
//   $('body.template-suffix-icon-case-magsafe-iphone .option-selector label').click(function () {
//     const titleText = $('.product-form .product-title').text();
//     const text = $(this).find('span').text().trim();
//     currentSwatchSelect(titleText, text);
//   });
// });

// Remove all dropdown options except for "Stealth Black" in Klaviyo back in stock notification dropdown

// $(document).ready(function () {
//   $('.template-suffix-icon-case-magsafe-iphone .klaviyo-bis-trigger').click(function () {
//     setTimeout(() => {
//       const iframeDocument = document.querySelector(".template-suffix-icon-case-magsafe-iphone #klaviyo-bis-iframe").contentDocument;
//       const optionSelect = iframeDocument.querySelectorAll('#variants option');
//       optionSelect.forEach(function (e) {
//         if (e.innerText == "Ombre Space Navy" || e.innerText == "Black Glitter" || e.innerText == "Clear Glitter") {
//           e.remove();
//         }
//       });
//     }, "300");
//   });
// });

// Remove all dropdown options except for "Stealth Black" in Klaviyo back in stock notification dropdown

// $(document).ready(function () {
//   $('.template-suffix-icon-case-magsafe-iphone .klaviyo-bis-trigger').click(function () {
//     if ($('.product-form .product-title').text() == 'cru. Protective for Samsung Galaxy S24+') {
//       setTimeout(() => {
//         const iframeDocument = document.querySelector(".template-suffix-icon-case-magsafe-iphone #klaviyo-bis-iframe").contentDocument;
//         const optionSelect = iframeDocument.querySelectorAll('#variants option');
//         optionSelect.forEach(function (e) {
//           if (e.innerText == "Navy Canvas") {
//             e.remove();
//           }
//         });
//       }, "300");
//     }
//   });
// });

// Hide or Show shop pay button
$(document).ready(function () {
  setTimeout(() => {
    if($('.quantity-submit-row__submit .add-to-cart').attr('disabled')) {
      $('.shopify-payment-button').hide();
    } else {
      $('.shopify-payment-button').show();
    }
  }, "500");
  
  $('.option-selector label').click(function () {
    if($(this).attr('title') == 'Sold out') {
      $('.shopify-payment-button').hide();
    } else {
      $('.shopify-payment-button').show();
    }
  });
});

// Add Final Sale to select product color variants
// on load
// $(document).ready(function () {
//   const handle = $('input[name="productHandle"]').val();
//   const finalSaleExists = $('#finalSale').length != 1;
//   const val = $('.option-selector input:checked').val();
//     fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
//       .then(response => response.json())
//       .then(product => {
//         const tags = product.tags;
//         if (tags.indexOf("Final " + val) > -1 == true) {
//           if (finalSaleExists) {
//             $('<input type="hidden" id="finalSale" value="No Returns/Exchanges" name="properties[All Sales Final]" />').insertAfter($('input[name="productHandle"]'));
//             $('<span class="final__sale">Final Sale</span>').insertAfter($('.product-info__price .price__was'));
//             if ($('.product-price--large .price__was').text() != '') {
//               $('.final__sale').css('margin-left', '12px');
//             } else {
//               $('.final__sale').css('margin-left', '0px');
//             }
//           }
//         } else {
//           $('#finalSale').remove();
//           $('.final__sale').remove();
//         }
//       })
  
//   // on change
//   $('.option-selector input').change(function () {
//     const finalSaleExists = $('#finalSale').length != 1;
//     const val = $(this).val();
//     fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
//       .then(response => response.json())
//       .then(product => {
//         const tags = product.tags;
//         if (tags.indexOf("Final " + val) > -1 == true) {
//           if ($('.product-price--large .price__was').text() != '') {
//               $('.final__sale').css('margin-left', '12px');
//             } else {
//               $('.final__sale').css('margin-left', '0px');
//           }
//           if (finalSaleExists) {
//             $('<input type="hidden" id="finalSale" value="No Returns/Exchanges" name="properties[All Sales Final]" />').insertAfter($('input[name="productHandle"]'));
//             $('<span class="final__sale">Final Sale</span>').insertAfter($('.product-info__price .price__was'));
//             if ($('.product-price--large .price__was').text() != '') {
//               $('.final__sale').css('margin-left', '12px');
//             } else {
//               $('.final__sale').css('margin-left', '0px');
//             }
//           }
//         } else {
//           $('#finalSale').remove();
//           $('.final__sale').remove();
//         }
//       })
//   })
// });


// Add Coming Soon button text based on tag "Soon Color Variant"
// on load
// $(document).ready(function () {
//   const handle = $('input[name="productHandle"]').val();
//   const shipsByExists = $('#shipsBy').length != 1;
//   const val = $('.option-selector input:checked').val();
//     fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
//       .then(response => response.json())
//       .then(product => {
//         const tags = product.tags;
//         if (tags.indexOf("Ships " + val) > -1 == true) {
//           if (shipsByExists) {
//             $('<input type="hidden" id="shipsBy" value="9/30" name="properties[Ships By]" />').insertAfter($('input[name="productHandle"]'));
//             $('<span class="ships__by">Ships By: 9/30</span>').insertAfter($('.product-info__price .price__was'));
//             if ($('.product-price--large .price__was').text() != '') {
//               $('.ships__by').css('margin-left', '12px');
//             } else {
//               $('.ships__by').css('margin-left', '0px');
//             }
//           }
//         } else {
//           $('#shipsBy').remove();
//           $('.ships__by').remove();
//         }
//       })
  
//   // on change
//   $('.option-selector input').change(function () {
//     const shipsByExists = $('#shipsBy').length != 1;
//     const val = $(this).val();
//     fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
//       .then(response => response.json())
//       .then(product => {
//         const tags = product.tags;
//         if (tags.indexOf("Ships " + val) > -1 == true) {
//           if ($('.product-price--large .price__was').text() != '') {
//               $('.ships__by').css('margin-left', '12px');
//             } else {
//               $('.ships__by').css('margin-left', '0px');
//           }
//           if (shipsByExists) {
//             $('<input type="hidden" id="shipsBy" value="9/30" name="properties[Ships By]" />').insertAfter($('input[name="productHandle"]'));
//             $('<span class="ships__by">Ships By: 9/30</span>').insertAfter($('.product-info__price .price__was'));
//             if ($('.product-price--large .price__was').text() != '') {
//               $('.ships__by').css('margin-left', '12px');
//             } else {
//               $('.ships__by').css('margin-left', '0px');
//             }
//           }
//         } else {
//           $('#shipsBy').remove();
//           $('.ships__by').remove();
//         }
//       })
//   })
// });


// Add Coming Soon button text & Back In Stock button based on tag "Soon Color Variant"
// on load
$(document).ready(function () {
  const handle = $('input[name="productHandle"]').val();
  const val = $('.option-selector input:checked').val();
  fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
    .then(response => response.json())
    .then(product => {
      const tags = product.tags;
      const color = product.variants.find(({ option1 }) => option1 === `${val}`).available;
      if (tags.indexOf("Soon " + val) > -1 == true && color == false) {
        $('.klaviyo-bis-trigger').addClass('show');
        $('.quantity-submit-row__submit .add-to-cart[disabled], .quantity-submit-row__submit button[disabled]').after('<button class="btn btn--large coming-soon-btn" type="button" name="coming-soon" disabled="">Coming soon</button>');
        $('.quantity-submit-row__submit .add-to-cart[disabled], .quantity-submit-row__submit button[disabled]').not('.coming-soon-btn').hide();
      } else {
        $('.klaviyo-bis-trigger').removeClass('show');
        $('.coming-soon-btn').remove();
        $('.quantity-submit-row__submit .add-to-cart, .quantity-submit-row__submit button').show();
      }
    })

  // on change
  $('.option-selector input').change(function () {
    const val = $(this).val();
    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(response => response.json())
      .then(product => {
        const tags = product.tags;
        const color = product.variants.find(({ option1 }) => option1 === `${val}`).available;
        if (tags.indexOf("Soon " + val) > -1 == true && color == false) {
          $('.klaviyo-bis-trigger').addClass('show');
          $('.quantity-submit-row__submit .add-to-cart[disabled], .quantity-submit-row__submit button[disabled]').after('<button class="btn btn--large coming-soon-btn" type="button" name="coming-soon" disabled="">Coming soon</button>');
          $('.quantity-submit-row__submit .add-to-cart[disabled], .quantity-submit-row__submit button[disabled]').not('.coming-soon-btn').hide();
        } else {
          $('.klaviyo-bis-trigger').removeClass('show');
          $('.coming-soon-btn').remove();
          $('.quantity-submit-row__submit .add-to-cart, .quantity-submit-row__submit button').show();
        }
      })
  })
});

// Filter sidebar height based on screen size
$(document).ready(function () {
  if ($(window).width() > 999) {
    const winHeight = $(window).height();
    const filterHeight = winHeight - 320;
    $('.filters__inner.sticky-content-container').css('max-height', filterHeight);
  }  
});
